import React, { useEffect } from 'react'
import aos from "aos"
import "aos/dist/aos.css"

const Testimonial = () => {
  useEffect(()=>{
    aos.init({duration:3000});
    });
  return (
    <section className="testimonial-area page-section scroll-to-page" id="testimonial">
    <div className="custom-container">
      <div className="testimonial-content content-width">
        <div className="section-header">
          <h4 className="subtitle scroll-animation" data-animation="fade_from_bottom" style={{marginBottom:"42px"}}>
            <i className="lar la-comment" /> testimonial
          </h4>
          <h1 className="scroll-animation" data-animation="fade_from_bottom" data-aos="fade-up"
     data-aos-anchor-placement="top-bottom">Work with <span>+4 Brands</span></h1>
        </div>
        <div className="clients-logos">
          {/* <h4 className="scroll-animation" data-animation="fade_from_bottom">work with 60+ brands worldwide</h4> */}
          <div className="row align-items-center">
            <div className="col-md-3 scroll-animation" data-animation="fade_from_left">
              <img src="assets/images/ayur.png" alt="Client" style={{height:"87px",background:'white'}} />
            </div>
            <div className="col-md-3 scroll-animation" data-animation="fade_from_bottom">
              <img src="assets/images/kyc.jpg" alt="Client" />
            </div>
            <div className="col-md-3 scroll-animation" data-animation="fade_from_top">
              <img src="assets/images/stackerbee.png" alt="Client" style={{background:"white"}} />
            </div>
            <div className="col-md-3 scroll-animation" data-animation="fade_from_right">
              <img src="assets/images/hardwyn.png" alt="Client" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  )
}

export default Testimonial